import firebase from "firebase/app"
import "firebase/messaging"
import 'firebase/firestore'

firebase.initializeApp({
  apiKey: "",
  authDomain: "",
  projectId: "",
  storageBucket: "",
  messagingSenderId: "",
  appId: ""
})

if (!firebase.apps.length) {
  firebase.initializeApp(config)
}

navigator.serviceWorker
  .register("firebase-messaging-sw.js", {
    scope: "firebase-cloud-messaging-push-scope",
  })
  .then((registration) => {
    const messaging = firebase.messaging()

    messaging.useServiceWorker(registration)
  })
  .catch((err) => {
    console.log(err)
  })

export const db = firebase.firestore()

export default firebase